import React, { useState } from "react";
import moment from "moment";
import Alert from "../../../controls/Alert";
import useCostingExists from "../../../services/trips/useCostingExists";

const EditTripValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  }); 

  let field = null;
  let error = false;
  let errorMessage = "";

  const extraKeys = [record.uniqueCostingNo];
  const costingExists = useCostingExists({extraKeys});

  const checkLegs = (legs) => {
    const primaryDestinations = [];
    const flightDestinations = [];
    const primaryLegs = [];

    let errors = [];

    for (let i = 0; i < legs.length; i++) {
      const {destinationAirportCode, transportType} = legs[i];
      if (transportType !== "TRUCK") {
        flightDestinations.push(destinationAirportCode);
      }
      if (transportType === "PRIMARY") {
        primaryDestinations.push(destinationAirportCode);
        primaryLegs.push(legs[i]);
      }
    }
    if (primaryLegs.length < 1) {
      errors.push(`There are no primary legs in the route`);
    }
    for (let i = 0; i < legs.length; i++) {
      const {originAirportCode, transportType} = legs[i];
      if (transportType === "TRUCK" && flightDestinations.indexOf(originAirportCode) < 0) {
        errors.push(`Trucks origin (${originAirportCode}) must be linked to a flights destination`);
      }
      if (transportType === "ONWARD" && primaryDestinations.indexOf(originAirportCode) < 0) {
        errors.push(`An onward flights origin (${originAirportCode}) must be linked to a primary flights destination`);
      }
    }
    if (primaryLegs.length > 0) {
      for (let i = 1; i < primaryLegs.length; i++) {
        if (primaryLegs[i].originAirportCode !== primaryLegs[i - 1].destinationAirportCode) {
          errors.push(`There is a Hole in the route, the Primary legs origin and destinations are not connected`);
        }
      }  
    }
    for (let i = 0; i < legs.length; i++) {
      if (i === 0) continue;
      const {allowThroughCargo, originAirportCode, destinationAirportCode} = legs[i-1];
      const {techStop} = legs[i];
      if (techStop && !allowThroughCargo) {
        errors.push(`Tech Stop at ${destinationAirportCode} requires 'Through Allowed' to be set for the ${originAirportCode}-${destinationAirportCode} sector`);
      }
    }
    return errors;
  }

  if (!error && !moment(record.tripDate).isValid()) {
    error = true;
    errorMessage = "'Trip Date' does not contain a valid date";
  }
  
  if (!error && record.uniqueCostingNo && (!costingExists || !costingExists.data)) {
    error = true;
    errorMessage = "Please enter a valid 'Costing Number'";
  }

  if (!error) {
    const legErrors = checkLegs(record.legs);
    if (legErrors && legErrors.length > 0) {
      error = true;
      errorMessage = legErrors[0];
    }
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {        
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default EditTripValidator;